<template>
  <div>
    <template-item layout="flex" label="生成方式">
      <el-radio-group v-model="type">
        <el-radio :label="1">一项一{{ directionText }}</el-radio>
        <el-radio :label="2">单项多{{ directionText }}</el-radio>
      </el-radio-group>
    </template-item>
    <el-divider />
    <cascader-area v-if="type === 1" />
    <sequence-area v-if="type === 2" />
  </div>
</template>
<script>
import { RadioGroup, Radio, Dialog, Button, Tabs, TabPane } from "element-ui";
import { Divider } from "element-ui";
import CascaderArea from "./CascaderArea";
import SequenceArea from "./SequenceArea";
import TemplateItem from "@/components/excel/designer/template/TemplateItem";
export default {
  name: "designer-template-area",
  components: {
    TemplateItem,
    SequenceArea,
    CascaderArea,
    [Dialog.name]: Dialog,
    [Divider.name]: Divider,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  },
  props: {
    direction: {
      type: Number,
    },
  },
  computed: {
    directionText() {
      const { direction } = this.$props;
      switch (direction) {
        case 1:
          return "列";
        case 2:
          return "行";
        default:
          return "未知";
      }
    },
  },
  data() {
    return {
      type: 1,
    };
  },
};
</script>
